import {
  post, get, patch, destroy,
} from './index';

/**
     * Send request to get a products
     * @param {number} orgId organization id
     * @param {object} params api params for searching by name, start and end date
     * @returns Promise with http response regarding getting seasons
     */
export const getProducts = (orgId, params = {}) => {
  const {
    limit = 20,
    offset = 0,
  } = params;
  const queryParamString = new URLSearchParams({
    organization_id: orgId,
    limit,
    offset,
  }).toString();
  return get(`/api/v1/products?${queryParamString}`);
};

/**
     * Send request to update a product
     * @param {*} data new product data
     * @param {*} orgId organization id
     * @param {*} productId product id
     * @returns Promise with http response regarding editing a product
     */
export const updateProduct = (data, orgId, productId) => patch(`/api/v1/products/${productId}?organization_id=${orgId}`, data);

/**
     * Send request to remove a product
     * @param {*} productId product id
     * @param {*} orgId organization id
     * @returns Promise with http response regarding removing a product
     */
export const removeProduct = (productId, orgId) => destroy(`/api/v1/products/${productId}?organization_id=${orgId}`);

/**
     * Send request to create product
     * @param {*} data new product data
     * @param {*} orgId organization id
     * @param {*} productId product id
     * @returns Promise with http response regarding editing a product
     */
export const createProduct = (data, orgId) => post(`/api/v1/products?organization_id=${orgId}`, data);
